<template>
  <div class="mb-4 ">
    <CCard class="bg-style2">
<!--      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">-->
<!--        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption.filter(obj => { return (obj.key == lang) })[0].value }} </span>-->
<!--      </CCardHeader>-->
      <CCardBody>
        <IDPProfile class=" pt-5"/>

        <CRow  v-for="(objsI,index) in idp.item" :key="objsI._id" class="">
          <CCol col="12">
            <CCard class="bg-style mb-4 border-dark pb-4">
              <CCardHeader class="bg-gradient-dark text-white" >
                <span class="font-weight-bold h6"> <CIcon name="cil-bookmark" class="mr-2"/> <label class="font-weight-bold">{{ objsI.title.filter(item => { return (item.key === lang)})[0].value }} </label> </span>
              </CCardHeader>
              <CCardBody >
                <CRow>
                  <CCol col="12" v-if="objsI.description.length > 0">
                    <div v-html="objsI.description.filter(item => { return (item.key === lang)})[0].value"></div>
                  </CCol>

                  <CCol col="12">
                    <IDPInfomation :isCreated="isCreated" :isTalent="idp.isTalent" :idp="objsI.item" :index="index" :option="optionData" @update="onChangeCC" />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
<!---->
        </CRow>

        <CRow >
          <CCol class="text-right">
<!--            <CButton  class="ml-2" size="sm" color="success" shape="pill" variant="outline" @click="onSave">-->
<!--              <span class="font-weight-bold pr-1"><CIcon name="cil-save"/> {{ $t('save') }} 1</span>-->
<!--            </CButton>-->

<!--            <CButton  class="ml-2" size="sm" color="info" shape="pill" variant="outline" @click="onSend">-->
<!--              <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/> {{ $t('send') }} 1</span>-->
<!--            </CButton>-->


            <CButton v-if="buttom.isSave" class="ml-2" size="sm" color="success" shape="pill" variant="outline" :disabled="isActionBlocked" @click="onSave">
              <span class="font-weight-bold pr-1"><CIcon name="cil-save"/> {{ $t('save') }} </span>
            </CButton>

            <CButton v-if="buttom.isSend" class="ml-2" size="sm" color="info" shape="pill" variant="outline" :disabled="isActionBlocked" @click="onSend">
              <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/> {{ $t('send') }} </span>
            </CButton>

            <CButton v-if="buttom.isUnSend" class="ml-2" size="sm" color="danger" shape="pill" variant="outline" @click="onUnSend">
              <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/>  {{ $t('unsend') }} </span>
            </CButton>

            <CButton v-if="buttom.isRejected"  class="ml-2" size="sm" color="dark" shape="pill" variant="outline" @click="onRejected">
              <span class="font-weight-bold pr-1"><CIcon name="cil-loop-circular"/> {{ $t('reject') }} </span>
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>



  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import IDPProfile from "@/projects/views/E-Performances/IndividualDevelopmentPlan/components/IDPProfile.vue";
import IDPInfomation from "@/projects/views/E-Performances/IndividualDevelopmentPlan/components/IDPInfomation.vue";
import RequiredValidation from "@/projects/mixins/requiredValidation";
moment.locale('th')

export default {
  name: 'IDP',
  components: {IDPInfomation, IDPProfile},
  mixins: [RequiredValidation],
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    options: {
      type: Object,
      default: null
    }

  },

  data: function () {
    return {
      horizontal: { label:'col-3', input:'col-9' },
      collapseDuration: 0,
      idp : {},

      buttom:{
        isSave : false,
        isSend : false,
        isUnSend : false,
        isRejected : false,

      },

      isCreated : false,

      body:null,
      isLookupLoading: true,
      isMethodLoaded: false,
      isCourseLoaded: false

    }
  },

  mounted() {

  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {

    async onInit() {
      this.isLookupLoading = true
      this.isMethodLoaded = false
      this.isCourseLoaded = false

      this.$store.dispatch("agency/config",{})
      this.onLoad();

      const [methodResult, courseResult] = await Promise.allSettled([
        this.$store.dispatch("idp/method",{}),
        this.$store.dispatch("idp/course",{})
      ])

      this.isMethodLoaded = methodResult.status === 'fulfilled'
      this.isCourseLoaded = courseResult.status === 'fulfilled'
      this.isLookupLoading = false
    },

    onLoad() {
      // this.idp = {}
      this.idp = this.$store.getters['idp/idp'];
      this.onCheckState();

    },
    onSave() {
      if (this.isActionBlocked) {
        return;
      }

      var body = {};
      body._id = this.idp._id;
      body.status = 0;
      body.year = this.options.year;
      body.item = this.idp.item;
      this.$store.dispatch("idp/config",body);


    },
    onSend() {
      if (this.isActionBlocked) {
        return;
      }

      if (!this.validateRequired()) {
        return;
      }

      var accounts = this.$store.getters["personal/profile"]._id;

      var isState = this.$store.getters["idp/idp"].status.at(-1);

      var body = {};
      body._id = this.idp._id;
      body.status = 1
      body.year = this.options.year;

      body.item = this.idp.item;


      var isSend = true;
      var isDisable = true;

      for(var i=0; i<this.idp.item.length; i++) {
        for(var j=0; j<this.idp.item[i].item.length; j++){
          var objs = this.idp.item[i].item[j];

          for(var il=0; il<objs.levels.length; il++){
            var ilevels = objs.levels[il];

            for(var k=0; k<ilevels.method.length; k++){
              var method = ilevels.method[k];
              if(method.code === null){
                isSend = false;
              }
              var isCheckBefore = method.developments.filter(obj => {
                if (obj.style === 3) {
                  return (
                      !obj.startDate || obj.startDate.trim?.() === "" ||
                      !obj.endDate || obj.endDate.trim?.() === ""
                  );
                } else {
                  return (
                      obj.hasOwnProperty('value') &&
                      (obj.value === null || obj.value === undefined || obj.value.trim?.() === "")
                  );
                }});

              if(isCheckBefore.length > 0){
                isSend = false;
              }

              if("67bc35d9ac0179614e274a67" === isState.state._id){
                var isCheckresults = method.results.filter(obj => {
                  if (obj.style === 3) {
                    return (
                        !obj.startDate || obj.startDate.trim?.() === "" ||
                        !obj.endDate || obj.endDate.trim?.() === ""
                    );
                  } else {
                    return (
                        obj.hasOwnProperty('value') &&
                        (obj.value === null || obj.value === undefined || obj.value.trim?.() === "")
                    );
                  }});
                if(isCheckresults.length > 0){
                  isSend = false;
                }
              }

              if(this.$store.getters["idp/idp"].assessor.accounts._id === accounts){

                if(method.verification.at(-1).status === false && method.verification.at(-1).comment === ''){
                  isSend = false;
                }
              }
              // if(method.code.length === 0 && objs.methods === "" && method.period.startDate === null && method.period.endDate === null ){
              //   isSend = false;
              // }

              if( method.verification.at(-1).status === false ){
                isDisable = false;
              }

            }

          }
        }
      }

      this.body = body;
      if(this.$store.getters["idp/idp"].accounts.accounts._id === this.$store.getters["personal/profile"].accounts._id ){
        if(isSend === false){
          var dialog = {
            message: this.$t('parameter.invalid'),
            code:"40300",
            number :"x",
            status:true
          }
          this.$store.commit("dialog/dialog",dialog)
        }else{
          this.$store.dispatch("idp/config",body);
        }
      }else{
        if(isSend === false){
          var dialog = {
            message: this.$t('parameter.invalid'),
            code:"40300",
            number :"x",
            status:true
          }
          this.$store.commit("dialog/dialog",dialog)
        }else if(isDisable === false){
          var dialog = {
            // title:"VERIFICATION",
            message: this.$t('idp.dialog.verification'),
            code:"00000",
            // icon:"cil-description",
            number :"0",
            status:true,
            actions: [
              { label: 'CONFIRM', code: 'verification', icon: 'cil-save' },
            ]
          }
          this.$store.commit("dialog/dialog",dialog)

        }else{
          this.$store.dispatch("idp/config",body);
        }
      }




      if(isSend === false){
        var dialog = {
          message: this.$t('parameter.invalid'),
          code:"40300",
          number :"x",
          status:true
        }
        this.$store.commit("dialog/dialog",dialog)
      }else{

      }
    },
    onUnSend() {},
    onRejected() {},


    onChangeCC(value, index) {
      this.idp.item[index].item  = value
    },

    onCheckState() {
      this.buttom.isSave = false;
      this.buttom.isSend = false;
      this.buttom.isUnSend = false;
      this.buttom.isRejected = false;

      var accounts = this.$store.getters["personal/profile"]._id
      var objs = this.$store.getters["idp/idp"].status.at(-1)

      if (!objs || !objs.state || !objs.state._id) {
        return;
      }

      switch (objs.state._id) {
      // switch ("654851a37ab25be71bbeeed6") {
        case "654851a37ab25be71bbeeed6": // Pending

            if(this.$store.getters["idp/idp"].accounts._id === accounts){
              this.buttom.isSave = true;
              this.isCreated = true;
            }

            if(this.$store.getters["idp/idp"].assessor.accounts._id === accounts){
            }

          break;
        case "654851dbe41b7f46025977f6": // Save
          if(this.$store.getters["idp/idp"].accounts._id === accounts){
            this.buttom.isSave = true;
            this.buttom.isSend = true;
            this.isCreated = true;
          }

          if(this.$store.getters["idp/idp"].assessor.accounts._id === accounts){

          }
          break;
        case "654851ece41b7f46025977fa": // Send
          if(this.$store.getters["idp/idp"].accounts._id === accounts){

          }

          if(this.$store.getters["idp/idp"].assessor.accounts._id === accounts){
            this.buttom.isSave = true;
            this.buttom.isSend = true;
          }

          break;

        case "6723709ab9a2030e40d1b884": // Reject
          if(this.$store.getters["idp/idp"].accounts._id === accounts){
            this.buttom.isSave = true;
            this.isCreated = true;
          }
          break;

        case "67bc20d5ef3c015b73cf6dbc": // Verification
          if(this.$store.getters["idp/idp"].assessor.accounts._id === accounts){
            this.buttom.isSave = true;
            this.buttom.isSend = true;
          }
          break;

        case "67bc35d9ac0179614e274a67": // development
          if(this.$store.getters["idp/idp"].accounts._id === accounts){
            this.buttom.isSave = true;
            this.buttom.isSend = true;
          }
          break;

        case "67bfc7e724e13ba338b58e47": // result in development
          if(this.$store.getters["idp/idp"].assessor.accounts._id === accounts){
            this.buttom.isSave = true;
            this.buttom.isSend = true;
          }

          break;

        case "67bfc7ed24e13ba338b58e4d": // complete

          break;

      }




    },


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      isCode:"dialog/isCode",
      dialogLoading:"dialog/loading",
    }),

    // Get option data from store to pass to child components
    optionData() {
      return {
        method: this.$store.getters['idp/method'] || [],
        course: this.$store.getters['idp/course'] || [],
        faculty: [] // placeholder if needed
      };
    },

    hasIdpData() {
      return Boolean(
        this.idp &&
        this.idp._id &&
        Array.isArray(this.idp.item) &&
        Array.isArray(this.idp.status) &&
        this.idp.status.length > 0
      );
    },

    isActionBlocked() {
      return this.isLookupLoading || !this.hasIdpData || !this.isMethodLoaded || !this.isCourseLoaded || this.dialogLoading;
    }
  },

  watch: {
    lang(value){

    },

    isCode(value){
      if(value === "verification"){
        this.$store.dispatch("idp/config",this.body);
        this.$store.commit("dialog/isCode",null)
      }
    }

  }
}
</script>
<style>

.a4-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.a4 {
  width: 210mm; /* ความกว้าง */
  height: 297mm; /* ความสูง */
  border: 1px solid #000; /* แสดงขอบกระดาษเพื่อให้มองเห็นได้ */
  padding: 20px;
  background: #fff;
  margin: 10px auto; /* จัดกึ่งกลาง */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* เพิ่มเงา */
  overflow: hidden; /* ซ่อนส่วนเกิน */
}

.page-content {
  overflow: visible; /* เนื้อหาแสดงผลทั้งหมดก่อนจัดหน้า */
}
.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
